<template>
  <div>
    <v-card>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex md12 sm12 xs12 pb-3>
              <h3>{{$t('generalInformation')}}:</h3>
            </v-flex>
            <v-flex md4 sm6 xs12>
              <v-text-field
                :rules="[v => rules.vacio(v,'name')]"
                required
                v-model="name"
                :disabled="isParticipant"
              >
                <template slot="label">
                  <span style="color: red">*</span>
                  {{$t('name')}}
                </template>
              </v-text-field>
            </v-flex>
            <v-flex md4 sm6 xs12>
              <v-text-field
                :rules="[v => rules.vacio(v,'lastname')]"
                required
                v-model="lastname"
                :disabled="isParticipant"
              >
                <template slot="label">
                  <span style="color: red">*</span>
                  {{$t('lastname')}}
                </template>
              </v-text-field>
            </v-flex>
            <v-flex md4 sm6 xs12>
              <v-text-field v-model="lastname2" :disabled="isParticipant">
                <template slot="label">{{$t('lastname2')}}</template>
              </v-text-field>
            </v-flex>
            <v-flex md4 sm6 xs12>
              <v-text-field
                :rules="[v => rules.vacio(v,'email'), rules.email]"
                required
                v-model="email"
              >
                <template slot="label">
                  <span style="color: red">*</span>
                  {{$t('email')}}
                </template>
              </v-text-field>
            </v-flex>
            <v-flex md4 sm6 xs12>
              <v-text-field
                :type="showPassword ? 'text' : 'password'"
                :label="$t('password')"
                v-model="password"
                counter
                :rules="[rules.min]"
                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                @click:append="showPassword = !showPassword"
              ></v-text-field>
            </v-flex>
            <v-flex md4 sm6 xs12>
              <v-text-field
                :type="showPassword ? 'text' : 'password'"
                :label="$t('repeatPassword')"
                v-model="password2"
                counter
                :rules="[rules.min]"
                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                @click:append="showPassword = !showPassword"
              ></v-text-field>
            </v-flex>
            <v-flex md6 sm6 xs12>
              <v-menu
                :close-on-content-click="false"
                :nudge-right="40"
                full-width
                lazy
                min-width="290px"
                offset-y
                ref="menu"
                transition="scale-transition"
                :disabled="isParticipant"
                v-model="menu"
              >
                <v-text-field prepend-icon="event" readonly slot="activator"  :disabled="isParticipant" v-model="date">
                  <template slot="label">{{$t('birthdayDate')}}</template>
                </v-text-field>
                <v-date-picker
                  :max="new Date().toISOString().substr(0, 10)"
                  @change="save"
                  min="1950-01-01"
                  ref="picker"
                  :disabled="isParticipant"
                  v-model="date"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex md6 sm6 xs12>
              <v-select
                :items="geners"
                v-model="sex"
                required
                :rules="[v => rules.vacio(v,'sex')]"
                :disabled="isParticipant"
              >
                <template slot="label">
                  <span style="color: red">*</span>
                  {{$t('sex')}}
                </template>
              </v-select>
            </v-flex>
            <v-flex md4 sm6 xs12>
              <v-autocomplete
                :items="listCountries"
                :rules="[v => rules.vacio(v,'country')]"
                persistent-hint
                :disabled="isParticipant"
                prepend-icon="mdi-city"
                v-model="country"
              >
                <template slot="label">
                  <span style="color: red">*</span>
                  {{$t('select', {field :$tc('country') })}}
                </template>
              </v-autocomplete>
            </v-flex>
            <v-flex md4 sm6 xs12>
              <v-autocomplete
                :disabled=" country==='' || isParticipant"
                :items="listProvinces"
                :rules="[v => rules.vacio(v,'province')]"
                persistent-hint
                prepend-icon="mdi-city"
                v-model="province"
              >
                <template slot="label">
                  <span style="color: red">*</span>
                  {{$t('select', {field :$tc('province') })}}
                </template>
              </v-autocomplete>
            </v-flex>
            <v-flex md4 sm6 xs12>
              <v-autocomplete
                :disabled=" province==='' || isParticipant"
                :items="listCities"
                :rules="[v => rules.vacio(v,'town')]"
                persistent-hint
                prepend-icon="mdi-city"
                v-model="city"
              >
                <template slot="label">
                  <span style="color: red">*</span>
                  {{$t('select', {field :$tc('town') })}}
                </template>
              </v-autocomplete>
            </v-flex>
            <v-flex md4 sm6 xs12>
              <v-text-field :label="$t('address')" v-model="address" :disabled="isParticipant"></v-text-field>
            </v-flex>
            <v-flex md4 sm6 xs12>
              <v-text-field :label="$t('cp')" v-model="cp" :disabled="isParticipant"></v-text-field>
            </v-flex>

            <v-flex md4 sm6 xs12>
              <v-text-field :label="$t('phone')" v-model="phone" :disabled="isParticipant"></v-text-field>
            </v-flex>
            <v-flex md4 sm6 xs12>
              <v-text-field :disabled="true" prepend-icon="attach_file" v-model="titleFile">
                <template slot="label">{{$t('userImage')}}</template>
              </v-text-field>
              <upload-button
                :fileChangedCallback="fileChanged"
                :title="titleButton"
              />
            </v-flex>
            <v-flex md4 sm6 v-if="image" xs6>
              <div style="max-width: 200px">
                <!--<img :src="image" width="100%"/>-->
                <clipper-preview class="basic md" name="preview"></clipper-preview>
              </div>
            </v-flex>
            <v-flex md4 sm6 v-if="image" xs6>
              <div style="max-width: 200px">
                <clipper-basic :src="image" class="basic lg" preview="preview"></clipper-basic>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <hr pb-5>

      <v-card-text>
        <v-container>
          <v-flex md12 sm12 xs12 pb-3>
            <h3>{{$t('rolList')}}:</h3>
          </v-flex>
          <v-flex xs12>
            <div class="v-table__overflow">
              <table
                class="v-datatable v-table theme--light"
                style="width: 100%; text-align: left"
              >
                <thead>
                  <tr>
                    <th>{{$tc('role')}}</th>
                    <th>{{$t('items')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(role, index) in userRoles" :key="index+200">
                    <td>{{role.role}}</td>
                    <td>
                      <v-chip
                        v-for="(object, index) in role.objects"
                        small
                        color="primary"
                        dark
                        :key="index+220"
                      >{{object.name || ''}}</v-chip>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-flex>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <span style="color:red">*</span>
        <span>{{$t('messages.fieldRequired')}}</span>
        <v-spacer></v-spacer>
        <v-btn @click="updateForm()" color="warning" small>{{$t('update')}}</v-btn>
        <v-btn @click="toggleProfileModal()" color="primary" small>{{$t('cancel')}}</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import UploadButton from 'vuetify-upload-button'
import queueToast from '../../../helpers/queueToast'
import { clipperBasic, clipperPreview } from 'vuejs-clipper'
import { urlAvatar } from '../../../helpers/avatar'
import rules from '../../../helpers/rules'

export default {
  name: 'tabInformation',
  components: {
    UploadButton,
    clipperBasic,
    clipperPreview
  },
  mixins: [rules],
  data () {
    return {
      geners: [
        {
          text: this.$t('man'),
          value: 'male'
        },
        {
          text: this.$t('woman'),
          value: 'female'
        }
      ],
      notifications: false,
      sound: true,
      widgets: false,
      date: null,
      menu: false,
      country: '',
      province: '',
      city: '',
      image: '',
      file: '',
      titleFile: '',
      name: '',
      lastname: '',
      lastname2: '',
      password: '',
      password2: '',
      showPassword: false,
      sex: '',
      address: '',
      cp: '',
      phone: '',
      email: '',
      rolsTemplate: {
        rol: '',
        other: []
      },
      rolsSelect: []
    }
  },
  mounted () { },
  watch: {
    user (val) {
      if (val) {
        this.resetForm()
        this.updateUser()
      }
    },
    menu (val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    country: function (val) {
      this.province = ''
    },
    province: function (val) {
      this.city = ''
    }
  },
  computed: {
    ...mapState({
      user: state => state.users.userSelected,
      listAllRols: state => state.rols.list,
      listEntities: state => state.entities.listSelectEntities,
      listTeams: state => state.teams.listSelectTeams,
      listTournaments: state => state.tournaments.listSelectTournaments,
      listSelectUsers: state => state.users.listSelectUsers
    }),
    ...mapGetters({
      listCountries: 'countries/selectList',
      listAllProvinces: 'provinces/selectList',
      listRols: 'rols/selectList',
      listAllCities: 'cities/selectList'
    }),
    listProvinces () {
      if (!this.country) return []
      let me = this
      return this.listAllProvinces.filter(item => item.meta === me.country)
    },
    listCities () {
      if (!this.province) return []
      let me = this
      return this.listAllCities.filter(item => item.meta === me.province)
    },

    titleButton () {
      return this.image ? this.$t('change', { field: this.$t('image') }) : this.$t('upload', { field: this.$t('image') })
    },
    isParticipant () {
      return !this.isAdmin && this.hasRole('participant')
    },
    userRoles () {
      if (!this.user || !this.user.roles) return []
      return this.user.roles
    }
  },
  methods: {
    ...mapActions({
      setUpdate: 'users/setUpdateUser',
      toggleProfileModal: 'authentication/toggleProfileModal'
    }),
    save (date) {
      this.$refs.menu.save(date)
    },
    customFilter () {
      /** * A revision ***/
    },
    fileChanged (file) {
      if (file.size < 1) return
      this.createImage(file)
    },
    createImage (file) {
      this.file = file
      this.titleFile = file.name
      const image = new Image()
      const reader = new FileReader()
      const vm = this

      reader.onload = e => {
        vm.image = e.target.result
      }
      reader.readAsDataURL(file)
    },
    updateUser () {
      const User = this.user
      this.name = User.name
      if (User.birthdayDate) { this.date = User.birthdayDate.toString().substr(0, 10) }
      this.country = User.country
      const me = this
      setTimeout(function () {
        me.province = User.province
      }, 20)
      setTimeout(function () {
        me.city = User.town
      }, 20)
      this.image = User.photo
      this.file = ''
      this.titleFile = User.photo
      this.lastname = User.lastname1
      this.lastname2 = User.lastname2
      this.sex = User.gender
      this.email = User.email
      this.address = User.address
      this.cp = User.cp
      this.phone = User.telf
      this.rolsSelect = []
      if (User.roles) {
        User.roles.forEach(item => {
          let ObjectIds = []
          if (Array.isArray(item.objectId)) {
            ObjectIds = item.objectId
          } else {
            ObjectIds.push(item.objectId)
          }
          me.rolsSelect.push({
            rol: item.roleId,
            other: ObjectIds
          })
        })
      } else {
        this.rolsSelect.push(Object.assign({}, this.rolsTemplate))
      }
    },
    resetForm () {
      this.date = null
      this.country = ''
      this.province = ''
      this.city = ''
      this.image = ''
      this.file = ''
      this.titleFile = ''
      this.name = ''
      this.lastname = ''
      this.lastname2 = ''
      this.password = ''
      this.password2 = ''
      this.sex = ''
      this.address = ''
      this.cp = ''
      this.email = ''
      this.phone = ''
      this.rolsSelect.splice(0, this.rolsSelect.length)
      this.rolsSelect.push(Object.assign({}, this.rolsTemplate))
    },
    rolById (id) {
      return this.listAllRols.find(item => item._id === id)
    },
    statusRol (id) {
      const rol = this.rolById(id)
      if (!rol) {
        return true
      }
      return rol.type !== 'all'
    },
    listOthers (id) {
      const rol = this.rolById(id)
      if (!rol || !rol.type) return
      switch (rol.type) {
        case 'entities':
          return this.listEntities
        case 'teams':
          return this.listTeams
        case 'tournaments':
          return this.listTournaments
        case 'matches':
        case 'users':
          return this.listSelectUsers
      }
    },
    errorFormPaso1 () {
      let error = false
      let message = []
      let isResponse = false
      /* if (!this.date) {
          error = true
          message.push('No ha ingresado la fecha de nacimiento')
        } */
      if (!this.name && !isResponse) {
        error = true
        message.push(this.$t('error.required', { field: this.$t('name') }))
        isResponse = true
      }
      if (!this.lastname && !isResponse) {
        error = true
        message.push(this.$t('error.required', { field: this.$t('lastname') }))
        isResponse = true
      }
      if (!this.sex && !isResponse) {
        error = true
        message.push(this.$t('error.required', { field: this.$t('sex') }))
      }
      if (!this.email && !isResponse) {
        error = true
        message.push(this.$t('error.required', { field: this.$t('email') }))
        isResponse = true
      }
      if (!this.country && !isResponse) {
        error = true
        message.push(this.$t('error.required', { field: this.$tc('country') }))
        isResponse = true
      }
      if (!this.province && !isResponse) {
        error = true
        message.push(this.$t('error.required', { field: this.$tc('province') }))
        isResponse = true
      }
      if (!this.city && !isResponse) {
        error = true
        message.push(this.$t('error.required', { field: this.$tc('town') }))
        isResponse = true
      }
      if (this.password && this.password != this.password2 && !isResponse) {
        error = true
        message.push(this.$t('error.passwordDoNotMatch'))
        isResponse = true
      }
      return {
        error,
        message
      }
    },
    validarFormPaso1 () {
      const paso1 = this.errorFormPaso1()
      if (paso1.error) {
        queueToast(paso1.message)
      }
      return !paso1.error
    },
    validarForm () {
      const paso1 = this.errorFormPaso1()
      if (paso1.error) {
        queueToast(paso1.message)
        return false
      }
      return true
    },
    createUser () {
      return {
        email: this.email,
        telf: this.phone,
        birthdayDate: this.date,
        gender: this.sex,
        name: this.name,
        lastname1: this.lastname,
        lastname2: this.lastname2,
        countryId: this.country,
        provinceId: this.province,
        townId: this.city,
        address: this.address,
        cp: this.cp,
        photo: this.file
      }
    },
    updateForm () {
      if (!this.validarForm()) {
        return
      }
      let userLocal = this.createUser()
      userLocal._id = this.user._id
      if (this.password) userLocal.password = this.password
      this.setUpdate(userLocal)
    }
  }
}
</script>
